/* eslint-disable jsx-a11y/media-has-caption, react/no-danger, max-len */
import React, { createRef } from 'react';
import { CSSTransition } from 'react-transition-group';
import PT from 'prop-types';
import classNames from 'classnames';
import _ from 'lodash';
import { Responsive } from 'common/components';

// import { analytics } from 'common/utils';
import { SliderComponent, Footer, RabbiCredit } from 'client/components/common';
import { UserType, CategoriesType } from 'admin/components/propTypes';
import planeIcon from 'assets/client/imgs/icon-plane.png';

import * as css from './Main.scss';

export default class Main extends React.PureComponent {
	static propTypes = {
		className: PT.string,
		user: UserType,
		categories: CategoriesType.isRequired,
		items: PT.shape({}).isRequired,
		settings: PT.shape({}).isRequired,
		isStarted: PT.bool.isRequired,
		in: PT.bool.isRequired,
		history: PT.shape({}).isRequired,
		inAnimFreeze: PT.bool,
		match: PT.shape({
			path: PT.string,
		}).isRequired,
	};

	static defaultProps = {
		className: '',
		user: null,
		inAnimFreeze: false,
	};

	constructor(props) {
		super(props);
		this.categoryId = 'podcasts';
		this.scrollToRef = createRef();

		this.state = {
			animationState: '',
		};
	}

	componentDidMount() {
		document.querySelector('html').classList.add(css.mainPage);
		window.scrollTo({
			top: 0,
			behavior: 'instant',
		});
	}

	componentWillUnmount() {
		document.querySelector('html').classList.remove(css.mainPage);
	}

	scrollTo = () => {
		this.scrollToRef.current.scrollIntoView({ block: 'start', behavior: 'smooth' });
	};

	animate = (node, done) => {
		if (this.props.in) {
			this.setState({ animationState: 'in' });
			setTimeout(done, parseInt(css.animationInTime, 10));
		} else {
			this.setState({ animationState: 'out' });
			setTimeout(done, parseInt(css.animationOutTime, 10));
		}
	};

	renderRadar = () => {
		return (
			<div className={css.radarWrapper}>
				<div className={css.rotatedArrow} />
				<div className={css.dots} />
			</div>
		);
	};

	renderMainScreen = () => {
		const { mainTitle, mainSubtitle } = _.get(this.props, 'settings.general', '');
		const mainImage = _.get(this.props, 'settings.general.mainImage.url', '');
		const mainImageMobile = _.get(this.props, 'settings.general.mainImageMobile.url', '');
		const mainImageSrc = Responsive.isMatching(Responsive.DESKTOP) ? mainImage : mainImageMobile;

		return (
			<React.Fragment>
				<div className={css.mainScreen} style={{ backgroundImage: `url(${mainImageSrc})` }}>
					<div className={css.content}>
						<div className={css.title}>{mainTitle}</div>
						<div className={css.subtitle}>{mainSubtitle}</div>
					</div>
					<img src={planeIcon} alt="plane-icon" className={css.planeIcon} onClick={this.scrollTo} />
					{this.renderRadar()}
				</div>
			</React.Fragment>
		);
	};

	render() {
		const { className, isStarted, items, inAnimFreeze } = this.props;
		const { animationState } = this.state;
		const cssTProps = _.omit(this.props, [
			'className',
			'isStarted',
			'staticContext',
			'history',
			'match',
			'items',
			'location',
			'categories',
			'settings',
			'inAnimFreeze',
		]);

		return (
			<CSSTransition {...cssTProps} addEndListener={this.animate}>
				<div
					className={classNames(css.main, isStarted && css[animationState], className, {
						[css.inAnimFreeze]: inAnimFreeze,
					})}
				>
					{this.renderMainScreen()}
					<div ref={this.scrollToRef}>
						<SliderComponent items={items} />
					</div>
					<RabbiCredit className={css.rabbiCredit} theme="light" />
					<Footer className={css.footer} />
				</div>
			</CSSTransition>
		);
	}
}
